import { Card, Center, Container, Image, Stack, Text } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/elements/Button';
import { clearRedux, fetchUpdateGrMerchant } from './actions';
import { useTimer } from 'react-timer-hook';
import styles from './styles.scoped.css';
import IcRefresh from '../../components/icons/IcRefresh';
import { AppContext } from '../../contexts';

export default function UpdateGRMerchant() {
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const [disabled, setDisabled] = useState(false);
  const {
    dataUpdateGRMerchant, isLoadingUpdateGRMerchant
  } = useSelector((state) => state.gigrActivation);

  const { restart, minutes, seconds } = useTimer({
    expiryTimestamp: new Date(),
    onExpire: () => {
      setDisabled(false);
      dispatch(clearRedux('UpdateGRMerchant'));
    },
    autoStart: false
  });

  useEffect(() => {
    dispatch(clearRedux('UpdateGRMerchant'));
    setDisabled(false);
    setBreadcrumbs(['Update GR Pangkalan']);
  },[]);

  useEffect(() => {
    if(dataUpdateGRMerchant?.status === 'TOO_MANY_REQUEST' && !isLoadingUpdateGRMerchant) {
      const countDownTime = dataUpdateGRMerchant?.data?.countdownTime;
      const newExpiry = new Date();
      newExpiry.setSeconds(newExpiry.getSeconds() + countDownTime);
      setDisabled(true);
      restart(newExpiry);
    }else{
      setDisabled(false);
    }
  },[dataUpdateGRMerchant, isLoadingUpdateGRMerchant]);

  const _handleSyncData = () => {
    dispatch(fetchUpdateGrMerchant());
  };
  return(
    <Container size={'lg'}>
      <Card p={30} withBorder >
        <Stack ta="center">
          <Center>
            <img alt="illu-sync-gr" height={190} src={'assets/illu-async-data.svg'} width={220}/>
          </Center>
          <div className={styles.content}>
            <Text fw={500} fz={24} mb={16}>Sync Data GR Pangkalan</Text>
            <Button className={styles.btnIcon} disabled={disabled} onClick={_handleSyncData}>
              <IcRefresh className={styles.svg}/> Sync Data Sekarang
            </Button>
            {!isLoadingUpdateGRMerchant && dataUpdateGRMerchant?.status === 'TOO_MANY_REQUEST' &&
            <Text mt={8} size={12}>
              Sync Data GR Pangkalan dapat dilakukan setelah: <strong>{minutes}:{seconds}</strong>
            </Text>}
          </div>
        </Stack>
      </Card>
    </Container>
  );
}
